import { AssetLogo, SvgIconNames, Toggle } from '@toggle/design-system';
import { getAssetLogoFromEntity } from '@toggle/toggle';
import React from 'react';

import { ChartEntity } from '~/types/timeseries.types';

import styles from './ChartTypeSelectorItem.module.scss';

export interface ChartTypeSelectorItemProps {
  entity: ChartEntity;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ChartTypeSelectorItem = ({
  entity,
  isChecked,
  onClick,
  disabled = false,
}: ChartTypeSelectorItemProps) => {
  const {
    entity: mapped,
    isNotStockEntity,
    isFiEntity,
    iconName,
    subClassIcon,
  } = getAssetLogoFromEntity(entity);

  return (
    <div className={styles.wrapper}>
      <span className={styles.assetWrapper}>
        <AssetLogo
          entity={mapped}
          size={20}
          withFallback
          isNotStockEntity={isNotStockEntity}
          isFiEntity={isFiEntity}
          placeholderIconName={iconName as SvgIconNames}
          placeholderSubClassIcon={subClassIcon as SvgIconNames}
        />
        <span className={styles.assetTicker}>{entity.formattedTicker}</span>
      </span>
      <Toggle
        data-testid={`${entity.formattedTicker}toggle`}
        isChecked={isChecked}
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};
